import type { MessageSuggestion } from "@expert/shared-types";

import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import { useEffect } from "react";

import { getRootDispatcher } from "@/analytics";
import { useVerifiedCustomerStore } from "@/customer-info";
import { useSessionId } from "@/sdk";

export const useDigitalCompetencyListener = () => {
    const sessionId = useSessionId();
    useEffect(() => {
        const subscription = gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body }: GaiaWebSocketResponse) => {
            const message = body as MessageSuggestion;
            const digitalCompetency = message.suggestion.cues?.findLast((cue) => cue.type === "DIGITAL_COMPETENCY");
            if (digitalCompetency) {
                void getRootDispatcher().dispatchBusinessEvent("CustomerCueDetected", {
                    detectionSource: "GAIA",
                    cueType: digitalCompetency.type,
                    cueName: digitalCompetency.name,
                });
                useVerifiedCustomerStore.getState().setCustomer(sessionId, {
                    ...useVerifiedCustomerStore.getState().getVerifiedCustomer(sessionId).customer,
                    digitalCompetency: digitalCompetency.name,
                });
            }
        });
        return () => {
            subscription();
        };
        // oxlint-disable-next-line exhaustive-deps
    }, []);
};
